import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';

export class PlanningBeneficiaryCaredBy extends Enum {
  key!: string;
  getDescription!: (contactName: string) => string;

  static FAMILY_OR_ACQUAINTANCE: PlanningBeneficiaryCaredBy = {
    key: 'family_or_acquaintance',
    getDescription(contactName: string): string {
      return Lang.t('beneficiary.planning-family-or-acquaintance', {
        contactName: contactName || Lang.t('guidancestep.beneficiary')
      });
    }
  };

  static PRIVATE_PROFESSIONAL_FIDUCIARY: PlanningBeneficiaryCaredBy = {
    key: 'private_professional_fiduciary',
    getDescription(contactName: string): string {
      return Lang.t('beneficiary.planning-private-professional-fiduciary', {
        contactName: contactName || Lang.t('guidancestep.beneficiary')
      });
    }
  };

  static GOVERNMENT_AGENCY: PlanningBeneficiaryCaredBy = {
    key: 'government_agency',
    getDescription(contactName: string): string {
      return Lang.t('beneficiary.planning-government-agency', {
        contactName: contactName || Lang.t('guidancestep.beneficiary')
      });
    }
  };

  static isCaredByFamily(key: string): boolean {
    return key === this.FAMILY_OR_ACQUAINTANCE.key;
  }

  static isCaredByPrivateProfessional(key: string): boolean {
    return key === this.PRIVATE_PROFESSIONAL_FIDUCIARY.key;
  }

  static isCaredByGovernmentAgency(key: string): boolean {
    return key === this.GOVERNMENT_AGENCY.key;
  }
}
